import { Microfrontend } from '@cian/mf-react';
import { useApplicationContext } from '../../../utils/applicationContext';
import { useEffect, useRef } from 'react';
import { ICianMFUIElement } from '@cian/mf-registry/browser';
import { IWidgetManifest } from '../../../types/widgetManifest';

export const CalculatorPage = () => {
  const { config, logger } = useApplicationContext();
  const mcfRef = useRef<ICianMFUIElement>(null);
  const manifest = config.get<IWidgetManifest>('subsidizedMortgageCalculatorManifest');
  const eventName = config.getStrict<string>(
    'mortgage-calculator-micro-frontend.eventNameOnCalculateSubsidizedMortgage',
  );

  const mcfHandler = (e: CustomEvent) => {
    console.info('e.detail===', e.detail);
  };
  //ловим событие из микрофронта
  useEffect(() => {
    let ref: ICianMFUIElement | null = null;

    if (mcfRef?.current) {
      mcfRef.current.addEventListener(eventName, mcfHandler);
      ref = mcfRef.current;
    }

    return () => {
      if (ref) {
        ref.removeEventListener(eventName, mcfHandler);
      }
    };
  }, [eventName]);

  if (!manifest) {
    logger.error('Отсутствует манифест микрофронта Калькулятора субсидированной ипотеки', {
      domain: 'microfrontends.subsidized-mortgage-calculator.manifest',
    });

    return null;
  }

  return <Microfrontend {...manifest} ref={mcfRef} />;
};
